<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13fnryE/tc-custom/9780814337301.jpg?1741124861175" alt="This image is the cover for the book Earth Again, Made in Michigan Writers Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Earth Again, Made in Michigan Writers Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>Stirring meditations on living with a strong connection to the environment, both physical and psychological.</b> </p><p>The second full-length collection from award-winning poet Chris Dombrowski, <i>Earth Again</i>transports readers to an imaginative world where identity is explored and expanded. With a mixture of long poems and shorter pieces, Dombrowski probes birth, death, sex, memory, and our blessed but treacherous engagement with the natural world. While he writes from a number of points of view and employs both male and female speakers, much of the collection's singular insight centers around masculine identity and being a husband and a father. Readers come away transformed, "like the land / gasping as it does each late winter evening when / the sky at tree line, nearly sapphiric, goes black," as these poems prove Dombrowski to be a truly original American voice.</p><p> Comprised of three sections—each of which concludes with a long poem—<i>Earth Again</i>presents a range of narrative and emotions in dexterous rhythms, unexpected shifts, and unforgettable metaphors. Dombrowksi introduces readers to arresting images like "the parataxis of her ass," "cerulean, alchemical light," "Molly with the sun in her mouth," and "labyrinthine, lanky-stemmed, dew-magnified" leaves. These details combine with Dombrowski's note-perfect language, which alternates between the most colloquial and the most elevated of diction. Readers will be challenged to consider spirituality alongside Scooby-Doo Band-aids, and to meditate on death after the mower has chewed up a plastic dinosaur, as Dombrowski revels in exploring our connection to the environment and one another.</p><p> Fans of Dombrowski's previous collection, <i>By Cold Water</i>(which was noted as a contemporary poetry bestseller by the Poetry Foundation in 2009), along with other poets and poetry lovers will appreciate the attention to detail and the imaginative intensity of the poems in <i>Earth Again</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Dombrowski
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1d29a02